"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Filter;

var _immutable = require("immutable");

var _ActionTypes = require("../actions/ActionTypes");

var _FileExtensionFilters = _interopRequireDefault(require("../enums/FileExtensionFilters"));

var EMPTY_STATE = (0, _immutable.Map)({
  extensions: (0, _immutable.Set)(),
  reasons: (0, _immutable.Map)(),
  filterType: _FileExtensionFilters.default.NONE
});

function Filter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      filter = action.filter;

  switch (type) {
    case _ActionTypes.SET_FILTER:
      {
        return filter;
      }

    default:
      return state;
  }
}

module.exports = exports.default;